import React from "react";
import RegisterForShares from "./RegisterForShares";

const SignUpForG7 = () => {
  return <RegisterForShares />;
};

export default SignUpForG7;
